/********************************************************************************
 * Copyright (c) 2019 TypeFox and others
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 ********************************************************************************/
export function isSuccess(obj) {
    const success = obj?.success;
    return typeof success === 'string';
}
export function isError(obj) {
    const error = obj?.error;
    return typeof error === 'string' && Boolean(error);
}
export const VERSION_ALIASES = ['latest', 'pre-release'];
/** The permissions built into Open VSX. */
export const ADMIN_PERMISSIONS = {
    manageNamespaces: 'manage_namespaces',
    manageExtensions: 'manage_extensions',
    managePublishers: 'manage_publishers',
    manageScans: 'manage_scans',
    manageConsistency: 'manage_consistency',
    manageCaches: 'manage_caches',
    manageSearchIndex: 'manage_search_index',
    manageSettings: 'manage_settings',
    viewReports: 'view_reports'
};
export function isEqualUser(u1, u2) {
    return u1.loginName === u2.loginName;
}
export const CATEGORIES = [
    'AI',
    'Programming Languages',
    'Snippets',
    'Linters',
    'Themes',
    'Debuggers',
    'Formatters',
    'Keymaps',
    'SCM Providers',
    'Other',
    'Extension Packs',
    'Language Packs',
    'Data Science',
    'Machine Learning',
    'Visualization',
    'Notebooks'
];
//# sourceMappingURL=extension-registry-types.js.map